import { Action } from './types';

export const setAlert = (
  message: string | JSX.Element,
  type: 'success' | 'danger' = 'danger',
  timeout?: number,
): Action => {
  return { type: 'ALERT_SET', alert: { message, type, timeout } };
};

export const unsetAlert = () => {
  return { type: 'ALERT_DISMISS' };
};
